import { useMemo } from 'react';

import { useDataContext } from '../context/DataContext.tsx';
import { useSurfaceContext } from '../context/SurfaceContext.tsx';
import { evaluateChecks, type ValidationResult } from '../engine/validationEngine.ts';
import type { CheckRule } from '../types/A2UICommon.types.tsx';

export function useValidation(checks: CheckRule[] | undefined): ValidationResult {
	const { state, customFunctions } = useSurfaceContext();
	const { basePath } = useDataContext();
	const { dataModel } = state;

	return useMemo(
		() => evaluateChecks(checks, { dataModel, basePath, customFunctions }),
		[checks, dataModel, basePath, customFunctions],
	);
}
